import { ChangeDetectorRef, Component, HostBinding, Input, OnDestroy, OnInit, inject } from '@angular/core';
import {merge, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

import {CdkNavigationItem} from '@cdk/types';
import {CdkNavigationService} from '@cdk/components/navigation/navigation.service';
import {CdkSidebarService} from '@cdk/components/sidebar/sidebar.service';
import {LoginService} from '../../../../../app/main/auth/login/login.service';
import { NgClass, NgTemplateOutlet, NgStyle } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslateDirective } from '@ngx-translate/core';
import {MatIcon} from "@angular/material/icon";
import {MatTooltip} from "@angular/material/tooltip";

@Component({
    selector: 'cdk-nav-vertical-item',
    templateUrl: './item.component.html',
    styleUrls: ['./item.component.scss'],
    imports: [NgClass, RouterLink, RouterLinkActive, NgTemplateOutlet, MatIcon, TranslateDirective, NgStyle, MatTooltip]
})
export class CdkNavVerticalItemComponent implements OnInit, OnDestroy {
    private _changeDetectorRef = inject(ChangeDetectorRef);
    private _cdkNavigationService = inject(CdkNavigationService);
    private _cdkSidebarService = inject(CdkSidebarService);
    _loginService = inject(LoginService);

    @HostBinding('class')
    classes = 'nav-item';

    @Input()
    item: CdkNavigationItem;

    // Private
    private _unsubscribeAll: Subject<any>;

    isGrantedRole: boolean;
    isCoordenador: boolean;



    /**
     * Constructor
     */

    constructor() {
        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to navigation item
        merge(
            this._cdkNavigationService.onNavigationItemAdded,
            this._cdkNavigationService.onNavigationItemUpdated,
            this._cdkNavigationService.onNavigationItemRemoved
        ).pipe(takeUntil(this._unsubscribeAll))
            .subscribe(() => {

                const badge = this.item.badge;

                if (badge) {
                    delete this.item['badge'];
                    this._changeDetectorRef.detectChanges();
                    this.item['badge'] = badge;
                }

                const badgeCompartilhada = this.item.badgeCompartilhada;

                if (badgeCompartilhada) {
                    delete this.item['badgeCompartilhada'];
                    this._changeDetectorRef.detectChanges();
                    this.item['badgeCompartilhada'] = badgeCompartilhada;
                }

                // Mark for check
                this._changeDetectorRef.markForCheck();
            });

        this.isGrantedRole = true;

        if (this.item.role) {
            this.isGrantedRole = false;
            if (Array.isArray(this.item.role)) {
                this.item.role.forEach((role) => {
                    if (!this.isGrantedRole) {
                        this.isGrantedRole = this._loginService.isGranted(role);
                    }
                });
            } else {
                this.isGrantedRole = this._loginService.isGranted(this.item.role);
            }
        }

        if (this.item.extraRole) {
            this.isGrantedRole = this.isGrantedRole && this.item.extraRole(this._loginService.getUserProfile());
        }

        this.isCoordenador = this._loginService.isCoordenador();
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(true);
        this._unsubscribeAll.complete();
    }

    /**
     * Handle click on nav item - fold sidebar if it's unfolded
     */
    onItemClick(): void {
        const navbar = this._cdkSidebarService.getSidebar('navbar');
        if (navbar && navbar.folded && !navbar.lockedFolded()) {
            navbar.foldTemporarily();
        }
    }
}
